import { render, staticRenderFns } from "./UpdateFAQ.vue?vue&type=template&id=4bd13298"
import script from "./UpdateFAQ.vue?vue&type=script&lang=js"
export * from "./UpdateFAQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports